class BrandModelsLoader extends HTMLElement {
  constructor() {
    super();
    this.storefrontAccessToken = this.dataset.storefrontToken;
    this.shopDomain = this.dataset.shopDomain;
    this.makeHandle = this.dataset.makeHandle;
    this.makeName = this.dataset.makeName;
    this.loadModels();
  }

  async loadModels() {
    try {
      const models = await this.fetchModels();
      if (models.length > 0) {
        this.renderModels(models);
      }
    } catch (error) {}
  }

  async fetchModels() {
    const query = `
      query GetModelsForMake($handle: String!) {
        metaobject(handle: {type: "make", handle: $handle}) {
          fields {
            key
            references(first: 3) {
              nodes {
                ... on Metaobject {
                  fields {
                    key
                    value
                  }
                }
              }
            }
          }
        }
      }
    `;

    const variables = {
      handle: this.makeHandle,
    };

    const response = await fetch(`https://${this.shopDomain}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    const data = await response.json();

    if (data.errors) {
      return [];
    }

    const makeNode = data.data?.metaobject;
    if (!makeNode) return [];

    const catalogModelsField = makeNode.fields.find((f) => f.key === 'catalog_models');
    if (!catalogModelsField?.references?.nodes) return [];

    const models = [];
    catalogModelsField.references.nodes.forEach((modelRef) => {
      const modelField = modelRef.fields?.find((f) => f.key === 'model');
      if (modelField?.value) {
        models.push(modelField.value);
      }
    });

    return models;
  }

  handleize(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  renderModels(models) {
    const modelsHtml = models
      .map((model) => {
        const modelHandle = this.handleize(model);
        return `
        <a href="/pages/auto-model/${this.makeHandle}-${modelHandle}" class="brand-list__model-link">
          ${this.escapeHtml(model)}
        </a>
      `;
      })
      .join('\n');

    this.innerHTML = modelsHtml;
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

customElements.define('brand-models-loader', BrandModelsLoader);
